import React, { InputHTMLAttributes } from 'react';

export interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
}

const LargeRadio = (props: Props): JSX.Element => {
  const { className, label, name, value, ...rest } = props;

  const id = `${name}-${value}`;
  return (
    <div className={`inline-block${className ? ` ${className}` : ''}`}>
      <input type='radio' name={name} value={value} id={id} className='hidden peer' {...rest} />
      <label
        htmlFor={id}
        className='inline-block h-12 lg:h-16 w-12 lg:w-16 pt-2 lg:pt-3 text-xl lg:text-3xl rounded-full text-center text-sapphire border-4 border-sapphire bg-sapphire-50 opacity-30 cursor-pointer hover:opacity-60 peer-checked:opacity-100 transition'
      >
        {label}
      </label>
    </div>
  );
};

export { LargeRadio };
